module.exports = __webpack_public_path__ + "static/media/29BDOS1.06d1f265.jpg";